/**
 * Slugs retirados y a donde va cada uno.
 *
 * Fuente unica de verdad de la consolidacion de duplicados que se canibalizaban
 * entre si. Lo consume:
 *   - scripts/generate-sitemap.js  -> los saca del sitemap (si no, Google pide
 *     la URL y se come un 301 cada vez: ruido en "Paginas con redireccion")
 *   - scripts/prerender-meta.js    -> no genera su fichero plano, y comprueba
 *     que cada uno tenga su linea en _redirects (si falta, revienta el build)
 *
 * El 301 en si vive en public/_redirects (Cloudflare Pages) y, cuando la web se
 * mude, en la config de nginx. Si anades algo aqui, anade tambien alli.
 *
 * Criterio para retirar: la pagina compite por las mismas consultas que otra
 * mejor posicionada y NO tiene clics propios en Search Console. Ninguna de las
 * de abajo tenia un solo clic en los 28 dias a 26-ago-2026.
 */
export const SLUGS_RETIRADOS = {
  // --- Cluster "deficit calorico" -----------------------------------------
  // Habia SEIS paginas para el mismo grupo de consultas y ninguna ganaba:
  // "deficit calorico", "calcular deficit calorico" y variantes salian en
  // posicion 38-64 (pagina 4 a 6) con ~1.100 impresiones y cero clics.
  //
  // El superviviente es -guia-completa-2026 porque es la unica con contenido
  // de verdad (11.831 caracteres; las demas rondan las 3.000). Justo esa
  // estaba en "Rastreada: actualmente sin indexar": Google la rastreo y no la
  // indexo, que es exactamente lo que pasa cuando el dominio repite el mismo
  // articulo seis veces. Quitando las otras cinco deberia poder indexarla.
  'deficit-calorico-que-es-como-calcularlo': 'deficit-calorico-guia-completa-2026',
  'deficit-calorico-explicado-facil': 'deficit-calorico-guia-completa-2026',
  'cuantas-calorias-para-perder-grasa': 'deficit-calorico-guia-completa-2026',
  'cuantas-calorias-debo-comer-para-perder-peso-2026': 'deficit-calorico-guia-completa-2026',

  // Esta es del mismo grupo pero su intencion real es "cuantas calorias al
  // dia", asi que va a la que ya gana esa consulta (7.327 impresiones,
  // 19 clics, posicion 8,7) y no a la de deficit.
  'cuantas-calorias-deberias-comer-para-perder-peso': 'cuantas-calorias-consumir-al-dia-calculadora',

  // --- Cluster "mejor app para contar calorias" ---------------------------
  // Aqui NO se toca lo que funciona: mejores-alternativas-a-myfitnesspal-2026
  // (24 clics), mejores-apps-para-contar-macros-2026 (20) y la landing
  // app-para-contar-calorias-con-foto (19) se quedan como estan. Solo se
  // retiran las que no tienen ni un clic.
  'apps-para-contar-calorias-con-foto-2026': 'app-para-contar-calorias-con-foto',
  'contador-de-calorias-gratis-2026-cual-es-la-app-mas-precisa': 'mejores-apps-contar-calorias-gratis-2026',

  // Las tres wayo-vs- sin trafico van a la comparativa de 10 apps, que desde
  // el 29-ago cubre MyFitnessPal, FatSecret y Cal AI dentro.
  // wayo-vs-fitia y wayo-vs-yazio SE QUEDAN: las consultas "X vs Y" entre
  // competidores sí tienen volumen propio (fitia vs myfitnesspal, yazio vs
  // lifesum, yazio vs fatsecret...) y ambas rankean en posicion 8,4-8,6.
  'wayo-vs-fatsecret': 'mejores-apps-nutricion-ia-2026',
  'wayo-vs-myfitnesspal': 'mejores-apps-nutricion-ia-2026',
  'wayo-vs-cal-ai-mejor-inteligencia-artificial-contar-calorias-2026': 'mejores-apps-nutricion-ia-2026',
};

/** Destino absoluto de un slug retirado (las landings no cuelgan de /blog). */
const LANDINGS = new Set(['app-para-contar-calorias-con-foto']);
export const destinoDe = (slug) => {
  const d = SLUGS_RETIRADOS[slug];
  return LANDINGS.has(d) ? `/${d}` : `/blog/${d}`;
};
